import api from '@/api/base'

export default {
  fetch(pin, company, crew) {
    return api().get(`/crew-dispatch/${pin}/${company._id}/${crew._id}`);
  },
  lister(pin, company, crew, url) {
    return api().get(`/crew-dispatch/${pin}/${company._id}/${crew._id}/${url}`);
  },
  members(pin, company, crew, members) {
    return api().post(`/crew-dispatch/${pin}/${company._id}/${crew._id}/employees`, members);
  },
  leads(pin, company, crew, leads) {
    return api().post(`/crew-dispatch/${pin}/${company._id}/${crew._id}/leads`, leads);
  },
  save_dispatch(pin, company, crew, dispatch) {
    return api().post(`/crew-dispatch/${pin}/${company._id}/${crew._id}/dispatch`, dispatch);
  }
}
